import type { PriceDetails } from '../graphql/schema/commonBackend/graphql'

export const sumPrices = (
  prices: PriceDetails[],
  key: Extract<keyof PriceDetails, 'priceInclVat' | 'priceExclVat' | 'vatAmount'>,
) => prices.reduce((sum, curr) => sum + curr[key], 0)
